module.exports = __webpack_public_path__ + "img/desc.f3aa242c.png";